// Resolves HTML snippets by key from window.__APP_HTML, which is
// populated by the /public/content/*.js files (loaded via <script> tags
// in index.html).
//
// Using a <script> tag (instead of fetching HTML files) makes the content
// editable in place after build and works even when index.html is opened
// directly from the local filesystem via file://, where fetch() of local
// files is blocked by browser security.
//
// The returned value is a Promise for backwards compatibility with the
// previous fetch-based implementation; it resolves synchronously because
// the data is already in memory by the time React mounts.

/**
 * Look up an HTML snippet by its key.
 *
 * @param {string} key - Entry key in window.__APP_HTML, matching the
 *   assignment in the corresponding /public/content/<key>.js file
 *   (e.g. "about_ru", "language_help_en").
 * @returns {Promise<string>} The HTML source as a string, or an empty
 *   string if the key is not found.
 */
export const loadHtml = (key) => {
    try {
        const store = typeof window !== 'undefined' ? window.__APP_HTML : null;
        if (store && typeof store[key] === 'string') {
            return Promise.resolve(store[key]);
        }
        console.warn(`htmlCache - window.__APP_HTML[${JSON.stringify(key)}] is not set`);
        return Promise.resolve('');
    } catch (err) {
        return Promise.reject(err);
    }
};
